import { ReactComponent as SvgCoinbase } from './Coinbase.svg.es.js';
import { ReactComponent as SvgMagicLink } from './MagicLink.svg.es.js';
import { ReactComponent as SvgMetaMask } from './MetaMask.svg.es.js';
import { ReactComponent as SvgPhantom } from './Phantom.svg.es.js';
import { ReactComponent as SvgWalletConnect } from './WalletConnect.svg.es.js';

const SvgWalletIcons = {
    'Wallet/Coinbase': SvgCoinbase,
    'Wallet/MagicLink': SvgMagicLink,
    'Wallet/MetaMask': SvgMetaMask,
    'Wallet/Phantom': SvgPhantom,
    'Wallet/WalletConnect': SvgWalletConnect
};

export { SvgWalletIcons };
//# sourceMappingURL=index.es.js.map
